module.exports = __webpack_public_path__ + "img/igi-logo.1fdf9f1.svg";